import React from "react";

import { Row, Col } from "components/layout";

import Feedback from "../Feedback";
import ProcessProgress from "../ProcessProgress";
import TimeStat from "../TimeStat";
import CbmStat from "../CbmStat";
import { UnloadingMethodCompact } from "../UnloadingMethod";
import { NextShiftMessage } from "../NextShift";

import trailerLoad from "../../assets/images/trailer.svg";
import forkliftImg from "../../assets/images/forklift.svg";
import conveyorImg from "../../assets/images/conveyor.svg";
import cartImg from "../../assets/images/cart.svg";
import mixedImg from "../../assets/images/mixed.svg";

export const LoadView = ({ code, variant }) => {
  return (
    <Row justify="center" align="middle" style={{ height: "100%" }}>
      <Col style={{ textAlign: "center" }}>
        <Feedback
          title="Trailer Loading"
          message={variant === "v2" ? "" : `CODE: ${code}`}
          img={<img src={trailerLoad} alt="trailer" />}
          styles={{
            message: {
              fontFamily: "'Roboto Mono', monospace",
              fontWeight: 600,
              fontSize: "4.2vw",
            },
          }}
        />
      </Col>
    </Row>
  );
};

export const LoadView2 = ({
  isBreakTime,
  progress,
  progressColor,
  totalTime,
  activeTime,
  baselineCbmah,
  currentCbmah,
  processMethod,
  unloadMethodCategory,
}) => {
  return (
    <Row align="middle" style={{ height: "100%" }}>
      <Col
        offset={!isBreakTime ? 0 : 1}
        span={!isBreakTime ? (processMethod === "forklift" ? 9 : 8) : 10}
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-evenly",
          padding: "1vw",
          borderRight:
            !isBreakTime && processMethod !== "forklift"
              ? "0.4vw solid #45494D"
              : 0,
        }}
      >
        <ProcessProgress
          label="Progress"
          progress={progress}
          progressColor={"white"}
          style={
            !isBreakTime
              ? processMethod === "forklift"
                ? {
                    width: "34vw",
                    height: "34vw",
                  }
                : {
                    width: "18vw",
                    height: "18vw",
                  }
              : {
                  width: "34vw",
                  height: "34vw",
                }
          }
          textStyles={
            !isBreakTime
              ? {
                  fontSize: "4vw",
                }
              : {
                  fontSize: "8vw",
                }
          }
          labelStyles={
            !isBreakTime 
              ? processMethod==='forklift'?{
                fontSize: "4vw"
              }: {
                  fontSize: "2vw",
                }
              : {
                  fontSize: "4vw",
                }
          }
        />
        {!isBreakTime && processMethod !== "forklift" && (
          <TimeStat
            label="Total Time"
            value={totalTime}
            styles={{
              value: {
                fontSize: "6vw",
                lineHeight: 1,
              },
              label: {
                fontSize: "3vw",
                lineHeight: 1,
              },
            }}
          />
        )}
      </Col>

      {isBreakTime ? (
        <Col
          offset={1}
          span={10}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Row>
            <NextShiftMessage>
              <span>Waiting for</span> <br />
              <span>work to</span>
              <br />
              <span>resume</span>
            </NextShiftMessage>
          </Row>
          <Row style={{ paddingTop: "8vh" }}>
            <TimeStat
              label="Total time"
              value={totalTime}
              styles={{
                value: {
                  color: "white",
                },
              }}
            />
          </Row>
        </Col>
      ) : (
        <Col
          offset={1}
          span={10}
          style={{
            height: "90%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Row>
            <TimeStat
              label={"Equipment Loading"}
              value={
                <img
                  src={trailerLoad}
                  alt="trailer"
                  style={{ width: "16vw", marginTop: "4vh" }}
                />
              }
              styles={{
                wrapper: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                },
                value: {
                  fontSize: "8vw",
                  lineHeight: 1,
                },
                label: {
                  color: "#FFFFFF",
                },
              }}
            />
          </Row>
          <Row style={{ paddingTop: "10vh",marginBottom:'6.5vh' }}>
            <TimeStat
              label={
                processMethod !== "forklift"
                  ? "Shift Active Time"
                  : "Total Time"
              }
              value={processMethod !== "forklift" ? activeTime : totalTime}
              styles={{
                value: {
                  color: progressColor,
                },
              }}
            />
          </Row>
        </Col>
      )}

      {!isBreakTime && processMethod !== "forklift" ? (
        <Col
          span={5}
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            justifyContent: "space-evenly",
            borderLeft: "0.4vw solid #45494D",
            padding: "2vw 3vw",
          }}
        >
          {processMethod ? (
            <Row>
              <Col>
                <UnloadingMethodCompact
                  title="Loading Method"
                  isLoad={true}
                  imgSrc={
                    {
                      cart: cartImg,
                      forklift: forkliftImg,
                      conveyor: conveyorImg,
                      mixed: mixedImg,
                    }[processMethod]
                  }
                  method={unloadMethodCategory}
                />
              </Col>
            </Row>
          ) : null}
          <Row>
            <Col>
              <CbmStat
                label="30 Day"
                bottomLabel="Average CPH"
                value={baselineCbmah}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <CbmStat
                label="Active Time"
                bottomLabel="Average CPH"
                value={currentCbmah}
                styles={{
                  value: {
                    color: progressColor,
                  },
                }}
              />
            </Col>
          </Row>
        </Col>
      ) : (
        !isBreakTime && (
          <Col
            span={4}
            style={{
              height: "80%",
            }}
          >
            <UnloadingMethodCompact
              title="Loading Method"
              isLoad={true}
              imgSrc={
                {
                  cart: cartImg,
                  forklift: forkliftImg,
                  conveyor: conveyorImg,
                  mixed: mixedImg,
                }[processMethod]
              }
              method={unloadMethodCategory}
            />
          </Col>
        )
      )}
    </Row>
  );
};
